var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatePending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.501 0C6.95994 0 0 6.95994 0 15.501C0 24.042 6.95994 31.002 15.501 31.002C24.042 31.002 31.002 24.042 31.002 15.501C31.002 6.95994 24.042 0 15.501 0Z",
    fill: "#FFC34B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.502 1.40894C7.73737 1.40894 1.41016 7.73615 1.41016 15.5007C1.41016 23.2653 7.73737 29.5925 15.502 29.5925C23.2665 29.5925 29.5938 23.2653 29.5938 15.5007C29.5938 7.73615 23.2665 1.40894 15.502 1.40894Z",
    fill: "#FFAA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 11.0171V9.09534H11.5312V11.0171C11.5312 13.1398 13.2519 14.8606 15.3746 14.8606C17.4973 14.8606 19.2181 13.1398 19.2181 11.0171V9.09534H20.4993V11.0171C20.4993 12.9465 19.433 14.6269 17.8575 15.5011C19.433 16.3753 20.4993 18.0557 20.4993 19.9852V21.9069H19.2181V19.9852C19.2181 17.8625 17.4973 16.1417 15.3746 16.1417C13.2519 16.1417 11.5312 17.8625 11.5312 19.9852V21.9069H10.25V19.9852C10.25 18.0557 11.3163 16.3753 12.8917 15.5011C11.3163 14.6269 10.25 12.9465 10.25 11.0171Z",
    fill: "#FFE9BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3709 14.2196C16.4542 14.2196 17.4038 13.7072 17.9332 12.9385H12.8086C13.338 13.7072 14.2876 14.2196 15.3709 14.2196Z",
    fill: "#FFE9BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60938 9.09529C9.60938 8.74151 9.89617 8.45471 10.25 8.45471H20.4992C20.853 8.45471 21.1398 8.74151 21.1398 9.09529C21.1398 9.44907 20.853 9.73587 20.4992 9.73587H10.25C9.89617 9.73587 9.60938 9.44907 9.60938 9.09529ZM9.60938 21.9069C9.60938 21.5531 9.89617 21.2663 10.25 21.2663H20.4992C20.853 21.2663 21.1398 21.5531 21.1398 21.9069C21.1398 22.2607 20.853 22.5475 20.4992 22.5475H10.25C9.89617 22.5475 9.60938 22.2607 9.60938 21.9069Z",
    fill: "#FFE9BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1719 20.6255C12.1719 19.918 12.7455 19.3444 13.453 19.3444H17.2965C18.0041 19.3444 18.5777 19.918 18.5777 20.6255H12.1719Z",
    fill: "#FFE9BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatePending);
export default __webpack_public_path__ + "static/media/statePending.daf03ef6f7a08a77ed07338ff83a6769.svg";
export { ForwardRef as ReactComponent };